<template>
  <div>
    <div v-if="!canSiteDataLockAccess && !user.readOnly" class="add-document" :class="{ disableButton: userIsStudyAdmin }">
      <div class="plus-sign pull-left" @click="openUploadModal()">
        <span class="plus">+</span>
      </div>
      <div class="pull-left cursor_pointer" @click="openUploadModal()">
        Add a source document
      </div>
      <div class="pull-left max-size">Max file size: 100mb</div>
      <div style="clear:both;"></div>
    </div>
    <b-modal ref="upload-modal" hide-footer hide-header>
      <div class="wrngCSS">Warning</div>
      <div class="d-block text-center upload-modal">
        <div class="description">
          Documents uploaded to this secure platform, including any containing PII, will be visible to all CRA roles associated with this study.
        </div>
        <div class="btnbindCSS">
          <div class="btn-grp mt-30">
            <div class="file-upload understand-button"><input type="file" id="myfile" name="myfile" class="file-input" @change="selectedFile()" @click="closeUploadModal()" />I understand</div>
          </div>
          <div class="btn-grp mt-30">
            <div class="file-upload btn-cancelcss" @click="closeUploadModal()">
              Cancel
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal ref="progress-modal" hide-footer hide-header>
      <div class="d-block text-center progress-modal">
        <div class="upload-file">Uploading file...</div>
        <img src="static/img/icn-csv.png" />
        <div class="pb-15">{{ fileName }}</div>
        <progress id="progressBar" value="0" max="100" class="progress"></progress>
        <div class="uploading-now">
          Uploading now. Thanks for being patient.
        </div>
        <div class="uploading-now delete pt-40">
          <span class="cursor_pointer" @click="cancelUpload()">Cancel upload</span>
        </div>
      </div>
    </b-modal>
    <table-component showEmpty noGutters :items="documents" :fields="formHistoryFields">
      <template slot="name" slot-scope="data">
        {{ data.row.item.name }}
        <span class="ml-5" @click="showFilePreviewModal(data.row.item)">
          <img class="quick-view-icon" data-toggle="modal" src="static/img/quick-view.png" />
        </span>
      </template>
      <template slot="createdAt" slot-scope="data">
        {{ new Date(data.row.item.createdAt) | formatUTCDate }}
      </template>
      <template slot="uploadedBy" slot-scope="data"> {{ data.row.item.createdByName }} ({{ data.row.item.createdByUserRole }}) </template>
      <template slot="size" slot-scope="data">
        {{ data.row.item.fileSize }}
      </template>
      <template slot="Download" slot-scope="data">
        <a v-if="canSiteTeamDownloadDocs && rolesAccessPermission()" @click="viewuploadDocument(data.row.item)" class="download cursor_pointer">Download</a>
      </template>
      <template slot="Delete" slot-scope="data">
        <a @click="deleteDocument(data.row.item.id)" class="delete cursor_pointer" :class="{ disableButton: userIsStudyAdmin }">Delete</a>
      </template>
    </table-component>
    <div id="docPreviewModal" class="modal fade" role="dialog">
      <div class="modal-dialog mobile-friendly-modal-dialog">
        <!-- Modal content-->
        <div class="modal-content mobile-friendly-modal-content">
          <div class="modal-header mobile-friendly-modal-header border-none p-0">
            <button type="button" class="btnclose close close pr-25" data-dismiss="modal">
              <span class="closeText">CLOSE</span>&nbsp;
              <span class="closeIcon">&times;</span>
            </button>
          </div>
          <div class="modal-body mobile-friendly-modal-body">
            <div style="height:600px;overflow-y:scroll;" v-if="pdfView">
              <pdf :src="ViewUrl" v-for="i in numPages" :key="i" :page="i"></pdf>
            </div>
            <img v-else-if="imgView" class="iframeLayout" :src="ViewUrl" />
            <iframe v-else class="iframeLayout" :src="ViewUrl" oncontextmenu="return false" frameborder="0"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableComponent from "@/components/common/table";
import swal from "sweetalert2";

import { approvalStatusText, verificationStatusText, historyStatusText, historyStatus } from "@/constants/form";

import { SITEDATALOCK, PI, RATER, SUB_PI, STUDY_COORDINATOR, HOME_HEALTH, CRA, CraUB } from "@/constants/authRoles";
import { mapGetters } from "vuex";
import { AclRule } from "vue-acl";
import toastr from "toastr";
import pdf from "vue-pdf";
import axios from "axios";
import nprogress from "nprogress";
import "nprogress/nprogress.css";

export default {
  name: "edc-form-source-documents",
  components: {
    TableComponent,
    pdf
  },
  props: ["documents", "studyId", "participantId", "responseId", "type", "participantInfo"],
  data() {
    return {
      xmlHTTP: "",
      uploadUrl: "",
      s3Id: "",
      fileName: "",
      approvalStatusText,
      verificationStatusText,
      historyStatusText,
      historyStatus,
      formHistoryFields: [
        {
          key: "name",
          label: "NAME",
          sortable: true
        },
        {
          key: "createdAt",
          label: "UPLOADED",
          sortable: true
        },
        {
          key: "uploadedBy",
          label: "BY",
          sortable: false
        },
        {
          key: "fileSize",
          label: "FILE SIZE",
          sortable: false
        },
        {
          key: "Download",
          label: "ACTIONS"
        },
        {
          key: "Delete",
          label: " "
        }
      ],
      ViewUrl: "",
      pdfView: false,
      imgView: false,
      canSiteTeamDownloadDocs: false,
      numPages: undefined
    };
  },
  mounted() {
    this.getSiteDetailsFact();
  },
  computed: {
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    userIsStudyAdmin() {
      return this.user.userRole === "StudyAdmin";
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canSiteDataLockAccess() {
      this.$acl.change(`${SITEDATALOCK}`);
      return this.$acl.check("userAccess");
    },
    canRaterAccess() {
      this.$acl.change(`${RATER}`);
      return this.$acl.check("userAccess");
    },
    canSubPiAccess() {
      this.$acl.change(`${SUB_PI}`);
      return this.$acl.check("userAccess");
    },
    canStudyCoordinatorAccess() {
      this.$acl.change(`${STUDY_COORDINATOR}`);
      return this.$acl.check("userAccess");
    },
    canHomeHealthAccess() {
      this.$acl.change(`${HOME_HEALTH}`);
      return this.$acl.check("userAccess");
    },
    canCraAccess() {
      this.$acl.change(`${CRA}`);
      return this.$acl.check("userAccess");
    },
    canCraUBAccess() {
      this.$acl.change(`${CraUB}`);
      return this.$acl.check("userAccess");
    }
  },
  methods: {
    getSourceDocuments() {
      this.$emit("getDocuments");
    },
    openUploadModal() {
      if (!this.userIsStudyAdmin) {
        this.$refs["upload-modal"].show();
      }
    },
    selectedFile() {
      const getFile = document.getElementById("myfile");
      const selectfile = getFile.files[0];
      const fileType = selectfile.name
        .split(".")[1]
        .toLowerCase()
        .trim();
      if (fileType === "zip" || fileType === "ppt" || fileType === "pptx") {
        this.$toastr.error("This file type is not supported.");
      } else {
        this.$api.getPreSignedUrlFact(this.studyId, this.participantId, this.responseId, this.type, this.participantInfo.siteId).then(
          response => {
            this.uploadUrl = response.body.preSignedUrl;
            this.s3Id = response.body.s3Id;
            document.getElementById("progressBar").value = 0;
            const selectedFile = document.getElementById("myfile");
            const file = selectedFile.files[0];
            if (file) {
              if (file.size < 104857600) {
                this.$refs["progress-modal"].show();
                const url = this.uploadUrl;
                this.fileName = file.name;
                this.$forceUpdate();
                this.xmlHTTP = new XMLHttpRequest();
                // xmlHTTP.upload.addEventListener("loadstart", loadStartFunction, false);
                this.xmlHTTP.upload.addEventListener("progress", this.progressFunction, false);
                this.xmlHTTP.addEventListener("load", this.transferCompleteFunction, false);
                this.xmlHTTP.addEventListener("error", this.uploadFailed, false);
                this.xmlHTTP.addEventListener("abort", this.uploadCanceled, false);
                this.xmlHTTP.open("PUT", url, true);
                this.xmlHTTP.setRequestHeader("Content-Type", file.type);
                //xmlHTTP.setRequestHeader('book_id','10');
                this.xmlHTTP.send(file);
              } else {
                this.$toastr.error("File size exceeds the maximum of 100 MB.");
                document.getElementById("myfile").value = null;
              }
            }
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while uploading the document.");
          }
        );
      }
    },
    progressFunction(evt) {
      const progressBar = document.getElementById("progressBar");
      if (evt.lengthComputable) {
        progressBar.max = evt.total;
        progressBar.value = evt.loaded;
      }
    },
    transferCompleteFunction() {
      const fileDetails = {};
      fileDetails.name = this.fileName;
      fileDetails.s3Id = this.s3Id;
      fileDetails.description = "";
      fileDetails.type = this.type;
      this.$api.postUploadFact(this.studyId, this.participantId, this.responseId, fileDetails, this.participantInfo.siteId).then(
        () => {
          this.getSourceDocuments();
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while uploading the document.");
        }
      );
      this.$refs["progress-modal"].hide();
      document.getElementById("myfile").value = null;
    },
    uploadFailed() {
      this.$toastr.error("Error while uploading the document.");
    },
    downloadDocument(id) {
      if (this.user.userRole === "Cra" || this.user.userRole === "CraUB") {
        this.$toastr.warning("Access is Denied");
      } else if (this.user.userRole === "Pi" || this.user.userRole === "SubPi" || this.user.userRole === "StudyCoordinator" || this.user.userRole === "HomeHealth" || this.user.userRole === "SiteDataLock") {
        this.$api.getDownloadUrlFact(this.studyId, this.participantId, this.responseId, id, this.participantInfo.siteId).then(
          response => {
            this.downloadUrl = response.body.preSignedUrl;
            window.open(this.downloadUrl, "_blank");
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while downloading the document.");
          }
        );
      }
    },
    deleteDocument(id) {
      if (!this.canSiteDataLockAccess && !this.user.readOnly && !this.userIsStudyAdmin) {
        swal({
          title: "Are you sure you want to delete the document?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#b8c7ce",
          cancelButtonColor: "#34537d",
          confirmButtonText: "Cancel",
          cancelButtonText: "Yes"
        }).then(({ dismiss }) => {
          if (dismiss === "cancel") {
            this.$api.deleteDocumentFact(this.studyId, this.participantId, this.responseId, id, this.participantInfo.siteId).then(
              () => {
                this.getSourceDocuments();
              },
              error => {
                this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while deleting the document.");
              }
            );
          }
        });
      } else {
        toastr.warning("Access restricted");
      }
    },
    cancelUpload() {
      this.xmlHTTP.abort();
      this.$refs["progress-modal"].hide();
      document.getElementById("myfile").value = null;
    },
    closeUploadModal() {
      this.$refs["upload-modal"].hide();
    },
    showFilePreviewModal(data) {
      nprogress.start();
      this.ViewUrl = "";
      this.numPages = 0;
      this.$api.getDownloadUrlFact(this.studyId, this.participantId, this.responseId, data.id, this.participantInfo.siteId).then(
        response => {
          if (response.body.preSignedViewUrl.includes("pdf")) {
            this.pdfView = true;
            const loadingTask = pdf.createLoadingTask(response.body.preSignedViewUrl);
            this.ViewUrl = loadingTask;
            this.ViewUrl.promise.then(pdf => {
              this.numPages = pdf.numPages;
              nprogress.done();
              window.$("#docPreviewModal").modal();
            });
          } else if (!!response.body.preSignedViewUrl && (response.body.preSignedViewUrl.toLowerCase().includes(".jpg") || response.body.preSignedViewUrl.toLowerCase().includes(".jpeg") || response.body.preSignedViewUrl.toLowerCase().includes(".png") || response.body.preSignedViewUrl.toLowerCase().includes(".svg") || response.body.preSignedViewUrl.toLowerCase().includes(".webp"))) {
            this.imgView = true;
            this.ViewUrl = response.body.preSignedViewUrl;
            nprogress.done();
            window.$("#docPreviewModal").modal();
          } else {
            this.pdfView = false;
            this.imgView = false;
            this.ViewUrl = response.body.preSignedViewUrl;
            nprogress.done();
            window.$("#docPreviewModal").modal();
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while viewing the document.");
        }
      );
    },
    rolesAccessPermission() {
      if (this.canPiAccess || this.canSubPiAccess || this.canStudyCoordinatorAccess || this.canHomeHealthAccess || this.canSiteDataLockAccess || this.canCraAccess || this.canCraUBAccess) {
        return true;
      } else {
        return false;
      }
    },
    getSiteDetailsFact() {
      if (this.participantInfo.siteId) {
        this.$api.getSiteDetailsFact(this.studyId, this.participantInfo.siteId).then(
          response => {
            this.canSiteTeamDownloadDocs = response.body.canSiteTeamDownloadEsourceDocs;
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the site details.");
          }
        );
      }
    },
    viewuploadDocument(data) {
      this.$api.getDownloadUrlFact(this.studyId, this.participantId, this.responseId, data.id, this.participantInfo.siteId).then(
        response => {
          if (response.body.preSignedViewUrl.toLowerCase().includes(".pdf") || response.body.preSignedViewUrl.toLowerCase().includes(".mp4") || response.body.preSignedViewUrl.toLowerCase().includes(".png") || response.body.preSignedViewUrl.toLowerCase().includes(".jpg")) {
            this.downloadImageWithAxios(response.body.preSignedUrl, data.name);
          } else {
            window.open(response.body.preSignedUrl);
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while viewing the document.");
        }
      );
    },
    downloadImageWithAxios(fileURL, fileName) {
      axios({
        method: "get",
        url: fileURL,
        responseType: "arraybuffer"
      })
        .then(response => {
          this.forceFileDownload(response, fileName);
        })
        .catch();
    },
    forceFileDownload(response, fileName) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", fileName); //or any other extension
      document.body.appendChild(link);
      link.click();
    }
  }
};
</script>
<style lang="scss" scoped>
.add-document {
  padding: 20px;
  color: #4c8ce4;
  font-weight: bold;
}

.disableButton {
  pointer-events: none;
  opacity: 0.5;
}

.progress {
  width: 400px;
  margin: 0 auto;
  height: 5px !important;
}

.download {
  color: #4c8ce4 !important;
}

.delete {
  color: #f16559 !important;
}

.upload-modal {
  padding: 40px;
  font-weight: bold;
}

.understand-button {
  background-color: #4c8ce4 !important;
  padding: 10px 50px;
  margin: 14px;
  color: #ffffff !important;
  border-radius: 100px;
  font-weight: normal !important;
}

.plus-sign {
  width: 17px;
  height: 17px;
  border-radius: 100px;
  background-color: #4c8ce4;
  color: #ffffff;
  text-align: center;
  margin-right: 5px;
  position: relative;
  top: 2px;
  cursor: pointer;
}

.plus {
  position: relative;
  bottom: 2.5px;
}

.progress-modal {
  padding: 20px;
}

.upload-file {
  font-size: 17px;
  font-weight: bold;
  margin-bottom: 30px;
}

.uploading-now {
  font-size: 12px;
  padding-top: 10px;
  color: #666669;
}

progress::-webkit-progress-value {
  background: #4c8ce4 !important;
}

.max-size {
  color: grey;
  font-size: 12px;
  font-weight: normal;
  margin: 3px 0 0 10px;
}

.quick-view-icon {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.modal-content {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #dcdcdc;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
  width: 1296px;
  right: 330px;
  height: auto;
}

.btnclose {
  position: relative;
  bottom: 30px;
  padding-bottom: 6px;
  opacity: 1;
}

.closeText {
  color: #ffffff;
  font-size: 12px;
  font-weight: 200;
}

.closeIcon {
  color: #ffffff;
  font-size: 20px;
  position: relative;
  top: 2.5px;
  right: 7px;
  font-weight: 200;
}

.iframeLayout {
  width: 100%;
  height: auto;
  position: relative;
  bottom: 0px;
  right: 0px;
}

.modal-content {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #dcdcdc;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
  width: 1296px;
  right: 330px;
  height: auto;
}

.btnclose {
  position: relative;
  bottom: 30px;
  opacity: 1;
}

.closeText {
  color: #ffffff;
  font-size: 12px;
  font-weight: 200;
}

.closeIcon {
  color: #ffffff;
  font-size: 20px;
  position: relative;
  top: 2.5px;
  right: 7px;
  font-weight: 200;
}

.btn-cancelcss {
  background-color: rgb(241, 101, 89);
  padding: 10px 50px;
  margin: 14px;
  color: #fff !important;
  border-radius: 100px;
  font-weight: normal !important;
}

.btnbindCSS {
  display: flex;
}

.wrngCSS {
  text-align: center;
  font-size: x-large;
  font-weight: bold;
}

@media (max-width: 1024px) {
  .iframeLayout {
    width: 100% !important;
    height: 100% !important;
    position: relative;
    bottom: 0px !important;
    right: 0px !important;
  }

  .mobile-friendly-modal-content {
    width: 100% !important;
    right: 0px !important;
    height: 100% !important;
  }

  .mobile-friendly-modal-body {
    padding: 0px !important;
  }

  .mobile-friendly-modal-dialog {
    width: 90% !important;
    padding-top: 55px !important;
  }

  .mobile-friendly-modal-header .close {
    padding: 4px !important;
    margin: -1rem -6px -1rem auto;
  }
}

.modal-body {
  padding: 0px 10px 10px 10px;
  margin-bottom: 0px;
}
</style>
